/*eslint-disable quotes */
import HttpHeader from './httpheader';
const CryptoJS = require('crypto-js');
const base64url = require('base64url');

const generateToken = (keyObj) => {
  console.log('generateToken');
  const header = {
    typ: 'JWT',
    alg: 'HS256',
  };

  const payloadObj = {
    iss: 'Portal-' + HttpHeader.getCNAME(),
    exp: Date.now() + 1800000,
    custom: {
      flow_name: 'landing',
      domain_oid: keyObj.DomainOid,
    },
  };
  console.log(payloadObj);
  //encode header
  const stringifiedHeader = CryptoJS.enc.Utf8.parse(JSON.stringify(header));
  const encodedHeader = CryptoJS.enc.Base64.stringify(stringifiedHeader);
  const base64URLHeader = base64url.fromBase64(encodedHeader);
  //Encoding Payload
  const payloadJson = JSON.stringify(payloadObj);

  const payLoadWordArray = CryptoJS.enc.Utf8.parse(payloadJson);
  console.log(payLoadWordArray);
  const base64EncodedPayload = CryptoJS.enc.Base64.stringify(payLoadWordArray);
  const encodePayload = base64url.fromBase64(base64EncodedPayload);

  console.log(encodePayload);

  //build token
  const token = base64URLHeader + '.' + encodePayload;

  const symmKey = CryptoJS.enc.Utf8.parse(keyObj.symmetricKey);
  console.log(symmKey);
  const base64EncodedsymmKey = CryptoJS.enc.Base64.stringify(symmKey);
  const symmKeybase64url = base64url.fromBase64(base64EncodedsymmKey);

  const payloadSignature = CryptoJS.HmacSHA256(token, symmKeybase64url);
  console.log('payloadSignature: ', payloadSignature);
  const base64Signature = CryptoJS.enc.Base64.stringify(payloadSignature);
  console.log('base64Signature: ', base64Signature);
  const base64URLSignature = base64url.fromBase64(base64Signature);
  const jwt = token + '.' + base64URLSignature;
  console.log('JWT: ', jwt);
  return jwt;
};

export default generateToken;
